// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderInfo":"c-n_fS"};